import Client from "../client";
import ProjectWorker from "@/entities/project-worker";

export default class ProjectWorkerApi {
  public constructor(private client: Client) {}

  /**
   * 全ての作業者
   */
  public async all(
    projectId: number,
    options: SearchOptions = {}
  ): Promise<ProjectWorker[]> {
    const data = await this.client.get("get_workers.php", {
      projectId,
      ...options
    });
    return data.map(toWorker);
  }

  /**
   * 現場にアサインされてない作業者
   * @param projectId
   * @param options
   */
  public async unassigned(
    projectId: number,
    options: SearchOptions = {}
  ): Promise<ProjectWorker[]> {
    const data = await this.all(projectId, options);
    return data.filter(m => !m.assigned);
  }

  /**
   * 現場にアサインされてない作業者
   * @param projectId
   * @param options
   */
  public async assigned(
    projectId: number,
    options: SearchOptions = {}
  ): Promise<ProjectWorker[]> {
    const data = await this.all(projectId, options);
    return data.filter(m => m.assigned);
  }
}

function toWorker(data: any): ProjectWorker {
  return {
    ...data,
    inviteStatus: toInviteStatus(data.inviteStatus)
  };
}

function toInviteStatus(id: number) {
  if (id === 1) {
    return "登録済";
  }
  if (id === 2) {
    return "招待済";
  }
  return "未招待";
}

interface SearchOptions {
  taskTypeIds?: string[];
  companyId?: string;
  favorite?: string;
}
